import { j as jsxRuntimeExports } from './../../../../ext/react/jsx-runtime.js';
import { Text } from '../Text/Text.js';
import styles from './FormError.module.css.js';

const FormError = ({ errorText, as = 'span' }) => {
    return errorText ? (jsxRuntimeExports.jsx(Text, { as: as, className: styles.error, type: "captionHeavy", children: errorText })) : null;
};

export { FormError };
//# sourceMappingURL=FormError.js.map
